import { forwardRef } from "react";

import { observer } from "mobx-react";

import { BasicInput, BasicInputProps } from "../BasicInput";

export interface NameInputProps extends BasicInputProps {
  type: "name";
}

export const NameInput = observer(
  forwardRef<HTMLInputElement, NameInputProps>(function NameInput(props, ref) {
    return <BasicInput ref={ref} leftIcon="input-person" {...props} />;
  })
);
